import {
  buildHtml,
  ContentRoute,
  createMapper,
  FactSheetContentGroup,
  RouteSlotInput,
} from '@caritas/ui';

import { isDefined } from '../../utils/is-defined';
import { mapHtmlBlock } from './HtmlBlock.mappers';

const mapFactSheetContent = createMapper<
  Array<BlockHtmlParagraphFragment | BlockHtmlListFragment>,
  RouteSlotInput<typeof FactSheetContentGroup, 'items'>
>({
  BlockHtmlParagraph: mapHtmlBlock,
  BlockHtmlList: mapHtmlBlock,
});

function isHtml(input: any): input is BlockHtmlParagraphFragment | BlockHtmlListFragment {
  return input && input.__typename && input.html;
}

export function mapFactSheet(
  input: BlockFactSheetFragment,
): RouteSlotInput<typeof ContentRoute, 'body', 'factSheetBlock'> {
  return {
    key: 'factSheetBlock',
    input: () => [
      {
        Title: input.injectedHeading
          ? buildHtml(input.injectedHeading)
          : undefined,
        items:
          input.factSheetItems?.filter(isDefined).map((item) => {
            return {
              Heading: buildHtml(item.factSheetHeading || ''),
              content: {
                items: mapFactSheetContent(
                  item.factSheetContent?.filter(isHtml) ||
                    ([] as Array<BlockHtmlParagraphFragment | BlockHtmlListFragment>),
                ),
              },
            };
          }) || [],
      },
      200,
    ],
  };
}
